import { styled } from 'styled-components'
import { Layout } from '../styled'
import { colors } from 'src/styles/theme'
import { SMALL_LAYOUT_MAX_WIDTH } from '../constants'

export const HeaderWrapper = styled(Layout.Header)`
  align-items: center;
  border-radius: 12px;
  display: flex;
  height: 89px;
  justify-content: space-between;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  position: fixed;
  top: 24px;
  width: 100%;
  max-width: 1200px;
  z-index: 1000;
  background-color: white;
  box-shadow: 0px 4px 14px 0px #0000001a;

  @media (max-width: ${SMALL_LAYOUT_MAX_WIDTH}) {
    left: 0;
    top: env(safe-area-inset-top, 0);
    width: 100%;
    height: 64px;
    border-radius: 0;
    padding: 12px 16px;
    background-color: white;
    box-shadow: 0px 2px 8px 0px #00000014;
    transform: unset;
  }

  @media (max-width: ${SMALL_LAYOUT_MAX_WIDTH}) {
    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: env(safe-area-inset-top, 0);
      background-color: white;
      z-index: 999;
    }
  }
`

export const DesktopContent = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 1;

  @media (max-width: ${SMALL_LAYOUT_MAX_WIDTH}) {
    display: none;
  }
`

export const MobileMenuButton = styled.div`
  display: none;
  align-items: center;

  .ant-btn {
    color: ${colors.primary};

    &:hover {
      color: ${colors.purpleMid};
      background-color: ${colors.neutral200};
    }
  }

  @media (max-width: ${SMALL_LAYOUT_MAX_WIDTH}) {
    display: flex;
  }
`

export const MobileDrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  align-items: flex-start;
`
